exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".salvataggioInCorso input{color:#8a2be2 !important}.salvataggioSuccess input{color:#9acd32 !important}.salvataggioError input{color:red !important}", ""]);

// exports
